"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HouseAllotmentCommittee = function HouseAllotmentCommittee(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 457.14641 457", className: "custom-icon" }, props),
    _react2.default.createElement("path", { d: "m453.742188 178.949219-78.632813-63.378907v-80.9375h5.125c5.054687 0 9.140625-4.09375 9.140625-9.144531s-4.085938-9.144531-9.140625-9.144531h-63.089844c-5.054687 0-9.144531 4.09375-9.144531 9.144531s4.089844 9.144531 9.144531 9.144531h5.125v38.351563l-87.957031-70.890625c-3.355469-2.695312-8.125-2.695312-11.480469 0l-219.429687 176.855469c-3.015625 2.433593-4.167969 6.503906-2.882813 10.160156 1.292969 3.65625 4.75 6.101563 8.625 6.101563h29.257813v252.863281c0 5.046875 4.089844 9.140625 9.144531 9.140625h361.9375c5.054687 0 9.140625-4.09375 9.140625-9.140625v-252.863281h29.375c3.875 0 7.332031-2.445313 8.625-6.101563 1.289062-3.65625.136719-7.726563-2.882812-10.160156zm-113.1875-144.316407h16.269531v66.199219l-16.269531-13.109375zm-148.890626 404.296876h-66.289062v-63.621094c0-18.277344 14.867188-33.140625 33.144531-33.140625 18.277344 0 33.144531 14.863281 33.144531 33.140625zm208.675782 0h-190.390625v-63.621094c0-28.355469-23.074219-51.425782-51.429688-51.425782s-51.429687 23.070313-51.429687 51.425782v63.621094h-50.402344v-243.71875h343.652344zm-365.285156-262.003907 193.519531-155.96875 193.515625 155.96875zm0 0" }),
    _react2.default.createElement("path", { d: "m294.054688 310.640625h69.714843c5.054688 0 9.144531-4.09375 9.144531-9.144531v-69.714844c0-5.046875-4.089843-9.140625-9.144531-9.140625h-69.714843c-5.054688 0-9.140626 4.09375-9.140626 9.140625v69.714844c0 5.050781 4.085938 9.144531 9.140626 9.144531zm9.144531-69.714844h51.425781v51.429688h-51.425781zm0 0" })
  );
};

exports.default = HouseAllotmentCommittee;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/houseallotmentcommittee.js
// module id = 1787
// module chunks = 895